import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Playlist from '../../models/playlist';
import LeaveBehindList from './leave-behind-list';
import LeaveBehindReplay from './leave-behind-replay';
import LeaveBehindTypes from '../../enum/leave-behind-types';
import './leave-behind.scss';

class LeaveBehind extends Component {

    constructor(props) {

        super(props);
        this.state = { countdown: props.countdown };

    }

    determineLeaveBehindType() {

        const {
            playlist,
            onSelectItem,
            type,
        } = this.props;
        const { countdown } = this.state;
        const listProps = {
            playlist,
            countdown,
            onSelectItem,
        };
        const replay = () => {

            onSelectItem(selected);

        };
        const selected = playlist.getSelectedItem();
        let component = undefined;

        switch(type) {

            case LeaveBehindTypes.LIST: {

                component = (<LeaveBehindList {...listProps} />);
                break;

            }
            default: {

                component = (<LeaveBehindReplay onClick={replay} mediaItem={selected} />);

            }

        }

        return component;

    }

    render() {

        const {
            playlist,
        } = this.props;
        const selected = playlist.getSelectedItem();

        return (
            <div className="leave-behind">
                <section className="content">
                    { this.determineLeaveBehindType() }
                </section>
            </div>
        );

    }

}

LeaveBehind.propTypes = {
    playlist: PropTypes.instanceOf(Playlist),
    countdown: PropTypes.number,
    onSelecItem: PropTypes.func,
    type: PropTypes.string,
};

LeaveBehind.defaultProps = {
    playlist: new Playlist([]),
    onSelectItem: () => null,
    countdown: 7,
    type: LeaveBehindTypes.LIST,
};

export default LeaveBehind;
